/**
 * The content lint as editing help (doc 05-admin/10 §2.1): the copy as typed, with each phrase
 * a rule matched marked in place, and the rule named under it ("outcome claim: ‘guaranteed
 * marriage’"). Nothing renders for clean copy. Save stays enabled — the server decides.
 */
import { segments, type LintHit } from '../lib/contentLint';

export function LintHint({
  text,
  hits,
}: {
  text: string;
  hits: readonly LintHit[];
}) {
  if (hits.length === 0) return null;
  const blocks = hits.some((h) => h.severity === 'block');
  return (
    <div
      role="status"
      aria-label="Content lint"
      style={{
        marginTop: 'var(--sp-xs)',
        padding: 'var(--sp-sm)',
        borderRadius: 'var(--r-input)',
        background: blocks ? 'var(--c-error-bg)' : 'var(--c-warn-bg)',
        color: blocks ? 'var(--c-error-text)' : 'var(--c-warn-text)',
        fontSize: 'var(--fs-admin-colhead)',
      }}
    >
      <p style={{ margin: 0 }}>
        {blocks
          ? 'The server will refuse this on save:'
          : 'This saves, and is flagged for review before it publishes:'}
      </p>
      <p style={{ margin: 'var(--sp-xs) 0', color: 'var(--c-ink)' }}>
        {segments(text, hits).map((s, i) =>
          s.flagged ? (
            <mark key={i}>{s.text}</mark>
          ) : (
            <span key={i}>{s.text}</span>
          ),
        )}
      </p>
      <ul style={{ margin: 0, paddingLeft: 'var(--sp-md)' }}>
        {hits.map((h) => (
          <li key={`${h.ruleId}-${h.start}`}>
            {h.ruleClass.replace(/_/g, ' ')}: ‘{h.matched}’ ({h.ruleId})
          </li>
        ))}
      </ul>
    </div>
  );
}
